import { render } from "./ResultAlertComponent.vue?vue&type=template&id=e8a76dfe"
import script from "./ResultAlertComponent.vue?vue&type=script&lang=js"
export * from "./ResultAlertComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__